import React, { useState } from 'react';
import './style.scss';

import {
  Webform as WebformComponent,
} from '@uncinc/react-drupal-core';

import WebformSelect from '@uncinc/react-drupal-core/dist/Components/Webform/WebformSelect';

import WebformHidden from '../WebformHidden';
import WebformDate from '../WebformDate';
import WebformFileUpload from '../WebformFileUpload';
import { webformAnalyticsFields } from '../../config/constants';

const Webform = (props) => {
  const [values, setValues] = useState(null);
  const [showLoader, setShowLoader] = useState(false);

  const overriddenComponents = {
    webform_entity_hidden: WebformHidden,
    hidden: WebformHidden,
    webform_entity_select: WebformSelect,
    date: WebformDate,
    managed_file: WebformFileUpload,
  };

  const pushEventOnSubmit = (data) => {
    const analyticsValues = {};
    webformAnalyticsFields.forEach((field) => {
      if (
        values &&
        Object.prototype.hasOwnProperty.call(values, field) &&
        values[field] !== undefined &&
        values[field] !== null &&
        values[field] !== ''
      ) {
        analyticsValues[field] = values[field];
      }
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submit',
      formId: props.id,
      ...analyticsValues,
    });
  };

  return (
    <div id="Webform" className="Webform__wrapper">

      {showLoader && (
        <div className="Backdrop">
          <div className="Backdrop__loader"><div /><div /><div /><div /></div>
        </div>
      )}

      <WebformComponent
        {...props}
        root
        overriddenComponents={overriddenComponents}
        onSubmit={(value) => {
          setShowLoader(true);
          setValues(value);
        }}
        onSuccessfullSubmit={(data) => {
          pushEventOnSubmit(data);
          setShowLoader(false);
        }}
        onFailedSubmit={() => setShowLoader(false)}
        onlySubmitVisibleFields
      />
    </div>
  );
};

export default Webform;
